import angular from 'angular';
import uiRouter from 'angular-ui-router';

import mapIngredientsComponent from './map-ingredients.component';
import './map-ingredients.scss';

export default
  angular.module('components.app.admin.map-ingredients', [
    uiRouter
  ])
    .component('mapIngredients', mapIngredientsComponent)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('mapIngredients', {
          parent: 'admin',
          url: '/map-ingredients',
          component: 'mapIngredients',
          resolve: {
            flex: () => '100',
            layout: () => 'column',
            query: IngredientService => IngredientService.getDefaultUserIngredientQuery(),
            queryMapped: IngredientService => IngredientService.getDefaultUserIngredientQuery()
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/map-ingredients/map-ingredients.module.js